import { Button } from "flowbite-react";
import { useState } from "react";
import icon1 from "../../../assets/images/Solution/icon1.svg";
import icon2 from "../../../assets/images/Solution/icon2.svg";
import icon3 from "../../../assets/images/Solution/icon3.svg";
import icon4 from "../../../assets/images/Solution/icon4.svg";
import Back1 from "../../../assets/images/Solution/Back1.webp";
import bonp from "../../../assets/images/Solution/bonp.webp";

export default function SolutionDagital() {
  const [isOpen, setIsOpen] = useState(false);

  const smoothScroll = (id) => {
    if (id === "top") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      const element = document.getElementById(id);

      if (element) {
        const headerElement = document.querySelector(".z-50.fixed");
        const headerHeight = headerElement?.offsetHeight || 0;

        const elementPosition = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    }
    setIsOpen(false);
  };
  return (
    <div className="w-full mt-10 ">
      <div
        className="w-full container mx-auto bg-bluer bg-center bg-cover bg-no-repeat md:rounded-[16px] md:mt-10 px-[20px] md:px-[120px]  py-[20px] grid grid-cols-1 lg:grid-cols-2 items-center gap-8 md:gap-4"
        style={{
          backgroundImage: `url(${Back1})`,
        }}
      >
        <div className="w-full flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <p className="text-[28px] font-semibold text-white ">
              Sẵn sàng để chuyển đổi số cho trung tâm của bạn ngay hôm nay?
            </p>
            <p className="text-[16px] font-normal text-white ">
              Tối ưu quản lý, nâng cao chất lượng giảng dạy và tăng hiệu quả kết
              nối giữa giáo viên, học viên và phụ huynh cùng{" "}
              <spam className="font-bold">Blue Rise</spam>
            </p>
          </div>
          <div className="w-full flex flex-col gap-3 lg:flex-row">
            <button
              href="/tai-xuong"
              className="h-[54px] rounded-[30px] w-full flex items-center bg-white text-black hover hover:bg-gray-200 justify-center"
            >
              Tải xuống
            </button>

            <button
              className="text-black h-[54px] w-full lg:w-full md:w-full bg-[#FDB62F] hover:bg-[#CA9226] rounded-[30px] flex items-center justify-center"
              onClick={() => {
                smoothScroll("advise");
                setIsOpen(false);
              }}
            >
              Nhận tư vấn ngay miễn phí
            </button>
          </div>
        </div>
        <div>
          <div className="w-full relative block md:hidden">
            <img src={bonp} alt="mki" className=" w-full h-auto object-cover" />
            <img
              src={icon1}
              alt="fw"
              className="w-12 h-12  absolute top-0 z-10 right-[25%] animate-bounce"
            />
            <img
              src={icon4}
              alt="bgg"
              className="w-12 h-12  absolute z-10 right-[25%] bottom-0 animate-bounce"
            />
            <img
              src={icon3}
              alt="dew"
              className="w-12 h-12  absolute z-10 top-44 right-3 animate-bounce"
            />
            <img
              src={icon2}
              alt="frwf"
              className="w-12 h-12  absolute z-10 top-10 right-3 animate-bounce"
            />
            {/* <img
              src={ranm}
              alt="bgf"
              className="absolute z-10 bottom-16 left-4"
            /> */}
          </div>
          <div className="hidden md:block w-full relative">
            <img
              src={bonp}
              alt="bvfd"
              className=" object-cover w-full h-auto"
            />
            <img
              src={icon1}
              alt="fd"
              className="  absolute top-0 z-10 right-[25%] animate-bounce"
            />
            <img
              src={icon4}
              alt="bdf"
              className="  absolute z-10 right-[25%] bottom-0 animate-bounce"
            />
            <img
              src={icon3}
              alt="bdf"
              className="  absolute z-10 top-80 right-3 animate-bounce"
            />
            <img
              src={icon2}
              alt="bdfbfd"
              className="  absolute z-10 top-20 right-3 animate-bounce"
            />
            {/* <img
              src={ranm}
              alt="bedj"
              className="absolute z-10 bottom-44 left-10 w-20"
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
